import { render, staticRenderFns } from "./PublishDetailsModal.vue?vue&type=template&id=6bddeecb&scoped=true"
import script from "./PublishDetailsModal.vue?vue&type=script&lang=js"
export * from "./PublishDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PublishDetailsModal.vue?vue&type=style&index=0&id=6bddeecb&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bddeecb",
  null
  
)

export default component.exports